<template>
    <app-modal :classContainer="'height--xs o-hidden'">
        <el-card class="box-card" v-if="show">
            <el-form @submit.native.prevent="saveProject" ref="form" label-position="top" id="project" >
                <el-row type="flex" justify="space-between">
                    <el-col :span="11">
                        <el-form-item label="Proyecto" >
                            <el-input  v-model="proyecto.proyecto"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <button v-if="proyecto.proyecto.length >= 3" type="submit" class="el-button el-button--primary" ><span>{{btn}}</span></button>
                        <el-button @click="closeModal()">Atrás</el-button>
                    </el-col>
                </el-row>
            </el-form>
        </el-card>
    </app-modal>
</template>
<script>
	import ApiService from "@/common/api.service";
    import Modal from '@/components/Dashboard/Modals/modal'

    export default {
        name: "addNewProject",
        props: ['content', 'project'],
        components: {
            'app-modal': Modal
        },
        created () {
            this.project != null ? this.getProject() : this.show = true;
        },
        data() {
            return {
                btn: 'Añadir',
                proyecto: {
                    proyecto: '',
                },
                showBottons: false,
                show: false,
            }
        },
        methods: {
            closeModal() {
                this.$root.$emit('closeModal')
            },
            async getProject(){
                ApiService.post("public/v1", {
                    token: localStorage.getItem("analiticatoken"),
                    single: true,
                    method: 'SELECT',
                    fields: ['id', 'proyecto'],
                    where: ' id = ' + this.project,
                    table: 'proyectos',
                }).then(response => {
                    if(response.data != 'Algo ha fallado'){
                        this.proyecto = response.data
                        setTimeout(() => {
                            this.show = true
                        }, 100);
                    }
                })
            },
            saveProject() {
                this.project != null ? this.update() : this.insert() ;
            },
            async insert() {
                ApiService.post("public/v1", {
                    token: localStorage.getItem("analiticatoken"),
                    single: true,
                    method: 'INSERT',
                    table: 'proyectos',
                    form: this.proyecto
                }).then(response => {
                    if(response.data != 'Algo ha fallado' && response.data != "El usuario ya existe"){
                        this.$root.$emit('msgSuccess', 'Registro insertado')
                        setTimeout(() => {
                            this.$root.$emit('closeModal')                    
                        }, 2000);
                    }else{
                        this.$root.$emit('msgError', response.data)
                    }
                })
            },
            async update() {
                let form = {proyecto: this.proyecto.proyecto} ;
                ApiService.post("public/v1", {
                    token: localStorage.getItem("analiticatoken"),
                    single: true,
                    method: 'UPDATE',
                    table: 'proyectos',
                    form: form,
                    id: this.project
                }).then(response => {
                    if(response.data != 'Algo ha fallado' && response.data != "El usuario ya existe"){
                        this.$root.$emit('msgSuccess', 'Registro insertado')
                        setTimeout(() => {
                            this.$root.$emit('closeModal')                    
                        }, 2000);
                    }else{
                        this.$root.$emit('msgError', response.data)
                    }
                })
            }

        }
    }
</script>


// WEBPACK FOOTER //
// src/components/Dashboard/Modals/addNewProject.vue